/**
 * PWA shell registration (story 0-2). featureKey: `pwa.shell` — registered in
 * the feature catalog by the flag-everything seed (1F-2); until the flag plane
 * exists (1B-2 capability document) registration is unconditional in prod.
 *
 * Dev builds skip registration: Vite serves modules directly and a controlling
 * worker only gets in the way of HMR. Verify via `vite build && vite preview`.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      // Non-fatal: the app is fully functional without the worker.
      console.warn('Service worker registration failed', error);
    });
  });
}
